import { defaultReferral } from "../../env-exports";
import { GetQuery } from "./getQuery";
import { normalizeHttpsUrl } from "./normalizeHttpsUrl";
import { getAndClearReferralUrl } from "./referralStorage";

export const RedirectToReferrer = () => {
  // Check sessionStorage first (for SSO flows), then query params, then default
  const result = getAndClearReferralUrl() ?? GetQuery().get("referral") ?? defaultReferral;

  if (result) {
    window.location.assign(normalizeHttpsUrl(result));
  }
};

export default RedirectToReferrer;
